var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3798 18.6172C25.0727 18.6172 23.819 19.1365 22.8947 20.0608C21.9704 20.9851 21.4512 22.2387 21.4512 23.5458",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4512 8.91895C21.4512 10.2261 21.9704 11.4797 22.8947 12.404C23.819 13.3283 25.0727 13.8476 26.3798 13.8476",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15381 13.8476C2.46097 13.8476 3.71459 13.3283 4.63889 12.404C5.5632 11.4797 6.08246 10.2261 6.08246 8.91895",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08246 23.5458C6.08246 22.8986 5.95498 22.2577 5.70729 21.6597C5.4596 21.0618 5.09656 20.5184 4.63889 20.0608C4.18123 19.6031 3.63789 19.24 3.03992 18.9924C2.44195 18.7447 1.80105 18.6172 1.15381 18.6172",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15381 8.91895H26.3798V23.5463H1.15381V8.91895Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6499 14.3499C15.6499 13.9775 15.5395 13.6134 15.3326 13.3038C15.1257 12.9941 14.8317 12.7527 14.4876 12.6102C14.1436 12.4677 13.765 12.4303 13.3997 12.5029C13.0344 12.5756 12.6989 12.7548 12.4355 13.0181C12.1722 13.2814 11.9928 13.6169 11.92 13.9822C11.8473 14.3474 11.8845 14.726 12.027 15.0701C12.1694 15.4142 12.4107 15.7083 12.7203 15.9153C13.0299 16.1223 13.3939 16.2328 13.7663 16.233",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8833 18.1155C11.8833 18.4879 11.9937 18.852 12.2007 19.1617C12.4076 19.4714 12.7017 19.7127 13.0458 19.8552C13.3898 19.9978 13.7685 20.0351 14.1337 19.9624C14.499 19.8897 14.8346 19.7104 15.0979 19.447C15.3613 19.1837 15.5406 18.8481 15.6133 18.4829C15.6859 18.1176 15.6486 17.739 15.5061 17.3949C15.3636 17.0508 15.1222 16.7567 14.8126 16.5498C14.5029 16.3429 14.1388 16.2324 13.7664 16.2324",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 11.7109V20.7548",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3815 21.0797H28.8461V6.4541H3.62012V8.91872",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3798 18.6172C25.0727 18.6172 23.819 19.1365 22.8947 20.0608C21.9704 20.9851 21.4512 22.2387 21.4512 23.5458",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4512 8.91895C21.4512 10.2261 21.9704 11.4797 22.8947 12.404C23.819 13.3283 25.0727 13.8476 26.3798 13.8476",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15381 13.8476C2.46097 13.8476 3.71459 13.3283 4.63889 12.404C5.5632 11.4797 6.08246 10.2261 6.08246 8.91895",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08246 23.5458C6.08246 22.8986 5.95498 22.2577 5.70729 21.6597C5.4596 21.0618 5.09656 20.5184 4.63889 20.0608C4.18123 19.6031 3.63789 19.24 3.03992 18.9924C2.44195 18.7447 1.80105 18.6172 1.15381 18.6172",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.15381 8.91895H26.3798V23.5463H1.15381V8.91895Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6499 14.3499C15.6499 13.9775 15.5395 13.6134 15.3326 13.3038C15.1257 12.9941 14.8317 12.7527 14.4876 12.6102C14.1436 12.4677 13.765 12.4303 13.3997 12.5029C13.0344 12.5756 12.6989 12.7548 12.4355 13.0181C12.1722 13.2814 11.9928 13.6169 11.92 13.9822C11.8473 14.3474 11.8845 14.726 12.027 15.0701C12.1694 15.4142 12.4107 15.7083 12.7203 15.9153C13.0299 16.1223 13.3939 16.2328 13.7663 16.233",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8833 18.1155C11.8833 18.4879 11.9937 18.852 12.2007 19.1617C12.4076 19.4714 12.7017 19.7127 13.0458 19.8552C13.3898 19.9978 13.7685 20.0351 14.1337 19.9624C14.499 19.8897 14.8346 19.7104 15.0979 19.447C15.3613 19.1837 15.5406 18.8481 15.6133 18.4829C15.6859 18.1176 15.6486 17.739 15.5061 17.3949C15.3636 17.0508 15.1222 16.7567 14.8126 16.5498C14.5029 16.3429 14.1388 16.2324 13.7664 16.2324",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 11.7109V20.7548",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3815 21.0797H28.8461V6.4541H3.62012V8.91872",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cashIcon.7a8c9a2317f8ff0097b5063e902d52a5.svg";
export { ForwardRef as ReactComponent };